import { useMemo } from 'react';
import dayjs from 'dayjs';

import { Study, StudyClient } from 'jf/api';
import { sortByISO } from 'jf/utils/sortByISO';
import { useClientQuery } from 'jf/utils/useClientQuery';

export const useSequenceStudies = (sequenceRef: string | undefined, status?: Study.status) => {
  const { data: studies } = useClientQuery(StudyClient.getStudies);

  const sequenceStudies = studies
    ?.filter((study) => study.sequenceRef === sequenceRef)
    .sort((a, b) => {
      const aDate = a.closeDate ? dayjs(a.closeDate) : dayjs(a.createdAt);
      const bDate = b.closeDate ? dayjs(b.closeDate) : dayjs(b.createdAt);
      return bDate.diff(aDate);
    });

  const statusStudies = useMemo(
    () =>
      sequenceStudies &&
      status &&
      sortByISO(sequenceStudies.filter((study) => study.status === status) ?? [], 'closeDate'),
    [sequenceStudies, status]
  );
  return status && sequenceStudies ? statusStudies : sequenceStudies;
};
